<template>
    <v-card class="p-3">
        <div class="d-flex justify-content-between">
            <h5>Notes</h5>

            <v-btn outlined class="custom-button-primary" :disabled="loadingNote" @click="updateNote">
                <v-icon>save</v-icon>

                <v-progress-circular class="progressbar ml-2" indeterminate size="20" v-if="loadingNote"
                                     color="#808080FF" width="2">
                </v-progress-circular>

            </v-btn>
        </div>

        <v-textarea outlined auto-grow hide-details v-model="note.content" @blur="checkNoteChanges">
        </v-textarea>

        <div class="d-flex justify-content-between" style="margin-top: 15px">
            <div class="mt-auto ml-3" style="color: #6c6b6b; font-style: italic; font-size: 14px"
                 v-if="note.updated_at !== undefined">
                Modifié le {{ formatDate(note.updated_at) }} par
                {{ note.user.first_name }} {{ note.user.last_name }}
            </div>
        </div>
    </v-card>
</template>

<script>
export default {
    name: "EntityNote",
    props: ["entityId" ,'entityNote'],
    data() {
        return {
            loadingNote: false,
            note: { content: null },
            lastNoteValue: { content: null },
        }
    },
    methods: {
        updateNote() {
            let payload = {
                entityId: this.entityId,
                note: this.note.content,
            }

            this.loadingNote = true

            this.$http.put("auth/sit-entity/update-note", payload).then(res => {
                if(res.body.success) {
                    this.loadingNote = false

                    this.$global.$emit("reload-entity")
                }
            })
        },
        checkNoteChanges() {
            if (this.note.content !== this.lastNoteValue.content) {
                this.updateNote()
            }
        },
    },
    created() {
        if(this.entityNote !== null) {
            this.note = this.entityNote
            this.lastNoteValue = JSON.parse(JSON.stringify(this.note))
        }
    }
}
</script>